// extracted by mini-css-extract-plugin
module.exports = {"Hero":"_43iIs","BackgroundSilverLight":"_1HR1c"};